var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', {
    attrs: {
      "color": "transparent"
    }
  }, [_c('main-section', [_c('lecture-categories'), _c('lecture-list-title', _vm._b({}, 'lecture-list-title', {
    title: _vm.title
  }, false)), _c('v-row', [_vm._l(_vm.items, function (value) {
    return [_c('v-col', {
      key: value._id,
      attrs: {
        "cols": "12",
        "md": "4"
      }
    }, [_c('lecture-list-card', _vm._b({}, 'lecture-list-card', {
      value
    }, false))], 1)];
  })], 2), _c('v-pagination', {
    attrs: {
      "value": _vm.page,
      "length": _vm.pageCount,
      "total-visible": 11,
      "color": "primary"
    },
    on: {
      "input": function (page) {
        return _vm.$router.push({
          query: Object.assign({}, _vm.$route.query, {
            page
          })
        });
      }
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }